import * as React from 'react';
import { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch, useLocation, useHistory } from 'react-router';

import { RouterProps, Navigate } from '../lib/types';
import { RouterContext } from '../context/RouterContext';

interface Props {
	router: RouterProps;
}

const Router: React.FC<Props> = ({ router }) => {
	const match = useRouteMatch();

	const history = useHistory();
	const location = useLocation();

	const basePath = match.path.replace(`/${router.path}`, '');
	const Layout = router.layout || React.Fragment;

	const [currentPath, setCurrentPath] = useState(router.path);

	useEffect(() => {
		const routePath = location.pathname.replace(basePath, '');

		setCurrentPath(routePath);
	}, [location]);

	const navigate: Navigate = (to, options = {}) => {
		const { state, replace } = options;
		const navigatePath = `${basePath}${to}`;

		if (replace) {
			history.replace(navigatePath, state);
		} else {
			history.push(navigatePath, state);
		}
	};

	return (
		<RouterContext.Provider value={{ basePath, currentPath, navigate }}>
			<Switch>
				{router.children.map(({ element, path, index, exact }) => {
					const routePath = index ? router.path : `${router.path}/${path}`;
					const routeFullPath = `${basePath}/${routePath}`;

					return (
						<Route key={routeFullPath} path={routeFullPath} exact={index || exact}>
							<Layout>{element}</Layout>
						</Route>
					);
				})}
			</Switch>
		</RouterContext.Provider>
	);
};

export default Router;
